import { render, staticRenderFns } from "./pointsMall.vue?vue&type=template&id=0b1c041d&scoped=true&"
import script from "./pointsMall.vue?vue&type=script&lang=js&"
export * from "./pointsMall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c041d",
  null
  
)

export default component.exports